export { EloBoldIcon } from './bold-icon'
